import React from 'react';
import { connect } from 'react-redux';
import { LinearProgress } from '@mui/material';

// Thin progress bar at the top of the window while requests are in flight.
// Replaces the full-screen spinner so the page stays visible while data loads.
const TopLoader = ({ pendingTasks }) =>
    pendingTasks > 0 ? (
        <LinearProgress
            color="secondary"
            sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: (t) => t.zIndex.modal + 1, height: 3 }}
        />
    ) : null;

const mapStateToProps = (state) => ({ pendingTasks: state.pendingTasks || 0 });

export default connect(mapStateToProps)(TopLoader);
